// sauberer bauen!!!

export { default as HandlebarsRuntime } from '../../node_modules/handlebars/dist/handlebars.runtime';
export { default as RegExp } from '../../node_modules/named-js-regexp/lib/named-js-regexp';
export { default as extend } from '../../node_modules/extend/index';